import React, { useEffect, useState } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import SelectFromField from 'CommonComponents/SelectFromField';
import TextFormField from 'CommonComponents/TextFormField';

import { useToast } from 'Hooks/useToast';

const SuppliersCreateSchema = Yup.object().shape({
    supplierName: Yup.string().required($t('This value is required')),
    supplierCode: Yup.string().required($t('This value is required')),
    contactName: Yup.string().required($t('This value is required')),
    contactEmail: Yup.string().email($t('Invalid email')).required($t('This value is required')),
    location: Yup.string(),
    postCode: Yup.string(),
});

export default function SuppliersCreateForm(props) {
    const [locations, setLocations] = useState([]);
    const toast = useToast();

    useEffect(() => {
        fetchLocations();
    }, []);

    const fetchLocations = () => {
        axios
            .get(props.suppliersCreateUrl)
            .then((response) => {
                setLocations(response.data.locations);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    return (
        <Formik
            initialValues={{
                forSponsor: props.supplierName !== '',
                supplierName: props.supplierName,
                supplierCode: '',
                contactName: '',
                contactEmail: '',
                location: '',
                postCode: '',
            }}
            validationSchema={SuppliersCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.suppliersStoreUrl, values)
                    .then((response) => {
                        if (props.successHandler) {
                            props.successHandler();
                        } else {
                            window.location.replace(props.suppliersIndexUrl);
                        }
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                        toast.error(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <div className={'tw-grid tw-grid-cols-12'}>
                    <div className={props.modal ? 'tw-col-span-12' : 'tw-col-start-2 md:tw-col-start-4 tw-col-span-10 md:tw-col-span-6'}>
                        <div className="tw-grid tw-grid-cols-1 tw-gap-4">
                            <TextFormField
                                label={$t('Supplier Name')}
                                required={true}
                                type="text"
                                name="supplierName"
                                placeholder={$t('Supplier Name')}
                            ></TextFormField>
                            <TextFormField
                                label={$t('Supplier Code')}
                                required={true}
                                type="text"
                                name="supplierCode"
                                placeholder={$t('Supplier Code')}
                            ></TextFormField>
                            <TextFormField
                                label={$t('Contact Name')}
                                required={true}
                                type="text"
                                name="contactName"
                                placeholder={$t('Contact Name')}
                            ></TextFormField>
                            <TextFormField
                                label={$t('Contact Email')}
                                required={true}
                                type="text"
                                name="contactEmail"
                                placeholder={$t('Contact Email')}
                            ></TextFormField>
                            <SelectFromField label={$t('Country')} as="select" name="location">
                                <option value={''}>{$t('Select Country')}</option>
                                {locations.map((location) => {
                                    return (
                                        <option key={location.isoCodeAlpha2} value={location.isoCodeAlpha2}>
                                            {location.name}
                                        </option>
                                    );
                                })}
                            </SelectFromField>
                            <TextFormField label={$t('PostCode')} type="text" name="postCode" placeholder={$t('Post Code')}></TextFormField>
                            <div className="modal__footer">
                                <Button variant="primary" disabled={isSubmitting ? true : false} onClick={handleSubmit}>
                                    {$t('Submit')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    );
}
